module.exports = __webpack_public_path__ + "joy-static/media/MoreTimeIcon.ec7fa91f.png";